<template>
  <v-container>
    <v-row>
      <v-expand-transition>
        <v-col
          v-if="audioUrl"
          cols="auto"
          class="px-0"
        >
          <v-tooltip
            top
            color="primary"
          >
            <template #activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                :disabled="loading || disabled"
                v-on="on"
                @click="deleteAudio"
              >
                {{ icons.mdiDelete }}
              </v-icon>
            </template>
          </v-tooltip>
        </v-col>
      </v-expand-transition>

      <v-expand-transition>
        <v-col
          v-if="audioUrl"
          cols="auto"
        >
          <audio
            :src="audioUrl"
            controls
          />
        </v-col>
      </v-expand-transition>

      <v-col
        cols="auto"
        class="px-0"
      >
        <v-expand-transition>
          <v-tooltip
            v-if="isRecording"
            top
            color="primary"
          >
            <template #activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                class="cursor-pointer"
                :disabled="loading || disabled"
                v-on="on"
                @click="stopRecording"
              >
                {{ icons.mdiStop }}
              </v-icon>
            </template>

            <span>Parar gravação</span>
          </v-tooltip>

          <v-tooltip
            v-else
            top
            color="primary"
          >
            <template #activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                class="cursor-pointer"
                :disabled="loading || disabled"
                v-on="on"
                @click="startRecording"
              >
                {{ icons.mdiMicrophone }}
              </v-icon>
            </template>

            <span>Gravar áudio</span>
          </v-tooltip>
        </v-expand-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
audio {
  max-width: 250px;
  max-height: 25px;
  margin: 0;
}
</style>

<script>
import { ref, onBeforeUnmount } from '@vue/composition-api'
import { mdiDelete, mdiMicrophone, mdiStop } from '@mdi/js'

export default {
  emits: ['update:audio-data-url', 'update:clicou-no-icone-de-audio'],

  props: {
    loading: Boolean,
    disabled: Boolean,
  },

  setup(_, { emit }) {
    const isRecording = ref(false)
    const audioUrl = ref(null)
    const mediaRecorder = ref(null)
    const recordedChunks = ref([])
    const audioDataUrl = ref(null)

    function startRecording() {
      emit('update:clicou-no-icone-de-audio', true)
      isRecording.value = true
      recordedChunks.value = []

      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(stream => {
          mediaRecorder.value = new MediaRecorder(stream)
          mediaRecorder.value.ondataavailable = e => {
            recordedChunks.value.push(e.data)
          }
          mediaRecorder.value.start()
        })
        .catch(() => {
          isRecording.value = false
        })
    }

    function convertBlobToDataUrl(blob) {
      const reader = new FileReader()
      reader.onloadend = () => {
        audioDataUrl.value = reader.result
        emit('update:audio-data-url', audioDataUrl.value)
      }
      reader.readAsDataURL(blob)
    }

    function stopRecording() {
      isRecording.value = false
      mediaRecorder.value.stop()
      mediaRecorder.value.onstop = async () => {
        const audioBlob = new Blob(recordedChunks.value, { type: 'audio/webm' })
        audioUrl.value = URL.createObjectURL(audioBlob)
        convertBlobToDataUrl(audioBlob)
      }
    }

    function deleteAudio() {
      audioUrl.value = null
      recordedChunks.value = []
      emit('update:audio-data-url', null)
      emit('update:clicou-no-icone-de-audio', false)
    }

    onBeforeUnmount(() => {
      if (mediaRecorder.value && mediaRecorder.value.state !== 'inactive') {
        mediaRecorder.value.stop()
      }
    })

    return {
      isRecording,
      audioUrl,
      startRecording,
      stopRecording,
      deleteAudio,
      icons: {
        mdiMicrophone,
        mdiStop,
        mdiDelete,
      },
    }
  },
}
</script>
